/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntegrationTestResultDto } from '../../models/integration-test-result-dto';

export interface IntegrationsControllerTestIntegration$Params {
  provider: string;
}

export function integrationsControllerTestIntegration(http: HttpClient, rootUrl: string, params: IntegrationsControllerTestIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationTestResultDto>> {
  const rb = new RequestBuilder(rootUrl, integrationsControllerTestIntegration.PATH, 'post');
  if (params) {
    rb.path('provider', params.provider, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntegrationTestResultDto>;
    })
  );
}

integrationsControllerTestIntegration.PATH = '/integrations/{provider}/test';
